module.exports = __WEBPACK_EXTERNAL_MODULE_survey_core__;